import * as Yup from 'yup';

export const inventoryEmailInitialValues = {
    searchText: '',
    date: null,
    amount: '',
};

export const inventoryEmailSchema = Yup.object({
    date: Yup.date().nullable(),
    amount: Yup.number().nullable(),
    searchText: Yup.string().nullable(),
});
